import getAllFocusable from './get-all-focusables';

export default function (element) {
	const focusableElements = getAllFocusable();
	const targetIndex = focusableElements.indexOf(element);
	if (targetIndex === -1) {
		const errorMessage = 'Previous focusable not found, is the argument  focusable?';
		throw errorMessage;
	}
	return targetIndex > 0 ? focusableElements[targetIndex - 1] : focusableElements[focusableElements.length - 1];
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/focus/get-previous-focusable.js